module.exports = __webpack_public_path__ + "img/11_windAndRain_pyy.36fa9631.png";